import React from 'react'
import { compose } from 'recompose'
import { connect } from 'formik'
import { IntlShape, injectIntl } from 'react-intl'
import Step from '@src/components/AdvertisingCampaign/Form/Step'
import GroupHead from '@src/components/AdvertisingCampaign/Form/GroupHead'
import Textarea from '@iui-kit/components/Textarea'
import * as FIELD_NAMES from '@src/constants/AdvertisingBriefs/Search/fieldNames'
import { Formik } from '@src/types/BriefSearch/formikProps'

interface HOCProps {
  formik: Formik
  intl: IntlShape
}

const StepOne: React.FC<HOCProps> = (props: HOCProps) => {
  const {
    formik: { handleChange, handleBlur, values, errors, touched },
    intl: { formatMessage }
  } = props

  return (
    <Step title="Brief.search.step.one.title">
      <GroupHead title="Brief.search.step.one.head.title" />
      <Textarea
        size="m"
        name={FIELD_NAMES.GOODS}
        onChange={handleChange}
        handleBlur={handleBlur}
        value={values[FIELD_NAMES.GOODS]}
        isValid={!errors[FIELD_NAMES.GOODS] || !touched[FIELD_NAMES.GOODS]}
        placeholder={formatMessage({ id: 'Brief.search.field.goods.placeholder' })}
      />
    </Step>
  )
}

export default compose<React.FC>(connect, injectIntl)(StepOne)
